"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.declineAllCookies = exports.acceptAllCookies = exports.areCookiesSaved = exports.updateCookiesBasedOnConsent = exports.getStoredConsent = void 0;
const js_cookie_1 = __importDefault(require("js-cookie"));
const routerUtils_1 = require("../../router/routerUtils");
const CURRENT_PREFERENCES_VERSION = 1;
const PREFERENCES_STORAGE_KEY = 'semfi_prefs';
const COOKIE_DEFAULTS = {
    sameSite: 'lax',
    secure: !routerUtils_1.isHttpLocation,
};
const categoryCookies = {
    necessary: {
    // 1. ts_gotoken session cookie
    // 2. datadog cookie
    },
    preferences: {
    // 1. frontend cookie TS_GO_PRE_LOGIN_ROUTER_STATE is under preferences category
    // and set in when user access a route without been logged in
    // and set when the user clicks the 'Go back to login' button
    },
    statistics: {
    // add statistics cookies here
    },
    marketing: {
    // add marketing cookies here
    },
};
const defaultConsent = {
    necessary: true,
    preferences: false,
    statistics: false,
    marketing: false,
};
const getStoredConsent = () => {
    const storedPrefs = localStorage.getItem(PREFERENCES_STORAGE_KEY);
    if (!storedPrefs) {
        return defaultConsent;
    }
    try {
        const prefs = JSON.parse(storedPrefs);
        if (prefs.version < CURRENT_PREFERENCES_VERSION) {
            return defaultConsent;
        }
        return prefs.consent;
    }
    catch {
        return defaultConsent;
    }
};
exports.getStoredConsent = getStoredConsent;
const savePreferencesToStorage = (consent) => {
    const preferences = {
        version: CURRENT_PREFERENCES_VERSION,
        consent,
        lastUpdated: new Date().toISOString(),
    };
    globalThis.localStorage.setItem(PREFERENCES_STORAGE_KEY, JSON.stringify(preferences));
};
const setCookie = (name, value, expires) => {
    js_cookie_1.default.set(name, typeof value === 'string' ? value : JSON.stringify(value), {
        ...COOKIE_DEFAULTS,
        expires,
    });
};
const removeCookie = (name) => {
    js_cookie_1.default.remove(name, COOKIE_DEFAULTS);
};
const updateCookiesBasedOnConsent = (consent) => {
    savePreferencesToStorage(consent);
    const oneYearFromNow = new Date();
    oneYearFromNow.setFullYear(oneYearFromNow.getFullYear() + 1);
    Object.entries(consent).forEach(([category, isAccepted]) => {
        const categoryKey = category;
        if (isAccepted) {
            Object.entries(categoryCookies[categoryKey]).forEach(([cookieKey, cookieValue]) => {
                setCookie(cookieKey, cookieValue, oneYearFromNow);
            });
        }
        else {
            Object.keys(categoryCookies[categoryKey]).forEach(cookieKey => {
                removeCookie(cookieKey);
            });
        }
    });
};
exports.updateCookiesBasedOnConsent = updateCookiesBasedOnConsent;
const isPreferencesVersionOutdated = () => {
    const storedPrefs = localStorage.getItem(PREFERENCES_STORAGE_KEY);
    if (!storedPrefs) {
        return true;
    }
    try {
        const prefs = JSON.parse(storedPrefs);
        return prefs.version < CURRENT_PREFERENCES_VERSION;
    }
    catch {
        return true;
    }
};
const areCookiesSaved = () => {
    return !isPreferencesVersionOutdated();
};
exports.areCookiesSaved = areCookiesSaved;
const acceptAllCookies = () => {
    const consent = {
        necessary: true,
        preferences: true,
        statistics: true,
        marketing: true,
    };
    (0, exports.updateCookiesBasedOnConsent)(consent);
};
exports.acceptAllCookies = acceptAllCookies;
const declineAllCookies = () => {
    const consent = {
        necessary: true,
        preferences: false,
        statistics: false,
        marketing: false,
    };
    (0, exports.updateCookiesBasedOnConsent)(consent);
};
exports.declineAllCookies = declineAllCookies;
